import React, { useEffect } from "react";
import { BrowserRouter as Router, useLocation } from "react-router-dom";

import Seo from "components/Seo";
import AppRoutes from "routes/AppRoutes";

// ScrollToTop component to handle scroll on route change
function ScrollToTop() {
  const location = useLocation();
  useEffect(() => {
    window.scrollTo({ top: 0, left: 0, behavior: "smooth" });
  }, [location.pathname]);
  return null;
}

function App() {
  return (
    <Router>
      <Seo />
      <ScrollToTop />
      <AppRoutes />
    </Router>
  );
}

export default App;
